// extracted by mini-css-extract-plugin
export var bannerContent = "style-mod--banner-content--8a826";
export var contentTd = "style-mod--content-td--c8f84";
export var description = "style-mod--description--dab7f";
export var founders = "style-mod--founders--ba528";
export var imgContent = "style-mod--img-content--1404a";
export var missionBanner = "style-mod--mission-banner--18627";
export var olavFounders = "style-mod--olav-founders--64ecb";
export var richText = "style-mod--rich-text--ea263";
export var signatureImg = "style-mod--signature-img--ba0f2";
export var tiBtn = "style-mod--ti-btn--eb6f1";
export var tiContent = "style-mod--ti-content--9e082";
export var title = "style-mod--title--bccf1";
export var topBorder = "style-mod--top-border--9da86";